import { render, staticRenderFns } from "./color_finder.vue?vue&type=template&id=5f50ed60"
import script from "./color_finder.vue?vue&type=script&lang=js"
export * from "./color_finder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports